module.exports = __webpack_public_path__ + "img/horizontal_3_2_8003.f1278248.png";